import '../App.css';
import { Button } from 'primereact/button';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import CampaignHeader from './CampaignHeader';
import Header from '../Header';
import { loadAllCampaigns } from '../QueryCampaign';

function Campaigns() {
    const navigate = useNavigate();
    const [campaigns, setCampaigns] = useState([]);

    const divCampaigns = campaigns.map(
        c =>
            <CampaignHeader
                campaign={c}
            />
    )

    useEffect(
        () => {
            loadAllCampaigns().then(
                (response) => {
                    setCampaigns(response.data);
                }
            ).catch(
                (error) => {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user_id');
                    navigate('/');
                }
            )
        },
        [],
    )

    return (
        <div style={{ marginTop: '4em' }}>
            <div>
                <Header />
                <div
                    className='standard-box2'
                    align='left'
                    style={{ width: '90%', marginTop: '2em' }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <Button
                            label="Setup New Campaign"
                            severity="success"
                            onClick={
                                () => {
                                    navigate('/campaigns/new');
                                }
                            }
                            style={{ marginLeft: '0.4em' }}
                            size='small'
                        />
                    </div>
                </div>
                {
                    campaigns.length <= 0 &&
                    <div
                        className='standard-box2'
                        align='left'
                        style={{ width: '90%' }}
                    >
                        {
                            <div>
                                You don't have any campaign right now.
                            </div>
                        }
                    </div>
                }
                {
                    campaigns.length > 0 &&
                    divCampaigns
                }
            </div>
        </div >
    );
}

export default Campaigns;